module.exports = __webpack_public_path__ + "images/stickers/taco-embarrassed.b84cc7c1ff4c870a78af.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-embarrassed.png
// module id = R0ms
// module chunks = 13